export const selectViewedStepResult = (
  latestResult: any,
  viewedStepResult: any,
  currentStep?: string,
) => {
  const source = viewedStepResult ?? latestResult ?? {};
  return {
    ...source,
    ...(currentStep ? { currentStep } : {}),
  };
};
